import { cn } from '@/lib/client'
import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'
import ButtonYoutube from '../atoms/button-youtube'

const videoAtom = atom<{ [key: string]: boolean }>({})

export default function VideoPlaceholder({
  url,
  title,
  img,
  width,
  height,
  className,
}: {
  url: string
  title: string
  img: string
  width: number
  height: number
  className?: string
}) {
  const $video = useStore(videoAtom)
  const isVisible = $video[url] || false

  const handleClick = () => {
    videoAtom.set({ ...$video, [url]: !isVisible })
  }

  return (
    <div className="basis-6/12 sm:flex sm:items-end cursor-pointer">
      {isVisible ? (
        <div className={cn('my-8 bg-zinc-900', className)}>
          <iframe
            title={title}
            loading="lazy"
            width={width}
            height={height}
            src={`${url}?autoplay=1&rel=0&showinfo=0`}
            allow="autoplay; encrypted-media"
            allowFullScreen
            className={className}
          />
        </div>
      ) : (
        <div className="relative" onKeyDown={() => {}} onClick={handleClick}>
          <img
            loading="lazy"
            src={img}
            alt={title}
            width={width}
            height={height}
            className={cn('cursor-pointer', className)}
            onClick={handleClick}
            onKeyDown={() => {}}
          />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16">
            <ButtonYoutube />
          </div>
        </div>
      )}
    </div>
  )
}
